/* Where each app lives on app.prajnainnovates.com. Every app has its own
   base path, like /interaction-map/; account-level pages (sign-in,
   workspaces, invites, admin) live under /account. */
export const CHECKLIST = '/cybhi-checklist';
export const ASSESSMENT = '/psychological-safety-assessment';
export const MAP = '/interaction-map/';
export const WORKSPACES = '/account/teams';
